import {makeAutoObservable} from 'mobx';

class LoginStore {
  username = '';
  password = '';
  usernameFocus = false;
  passwordFocus = false;

  constructor() {
    makeAutoObservable(this)
  }
}

let store = new LoginStore();

export default store;
